import axios from "axios";
import { STATE_URL } from "../../API/Api";

const getAllState = async (token) => {
  const headers = {
    Authorization: `Bearer ${token}`,
    Accept: "application/json",
  };
  const response = await axios({
    method: "GET",
    baseURL: `${STATE_URL}`,
    headers: headers,
  });
  return response.data;
};

const stateService = {
  getAllState,
};

export default stateService;
